import { create } from "zustand";

interface Vendor {
  uid: string;
  firstName?: string;
  lastName?: string;
  vendorCompanyName?: string;
  alias?: string;
  type?: string;
  status?: string;
  emails?: any[];
  phoneNumbers?: any[];
  [key: string]: any;
}

interface VendorsPaginated {
  items: Vendor[];
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
}

interface VendorStore {
  vendors: VendorsPaginated;
  vendorSearch: string | null;
  vendorForm: any;
  setVendorsPaginated: (vendors: VendorsPaginated) => void;
  addVendor: (vendor: Vendor) => void;
  updateVendorInList: (vendor: Vendor) => void;
  deleteVendorFromList: (uid: string) => void;
  setVendorForm: (form: any) => void;
  resetVendorForm: () => void;
}

export const useVendorStore = create<VendorStore>((set) => ({
  vendors: {
    items: [],
    page: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
  },
  vendorSearch: null,
  vendorForm: null,

  setVendorsPaginated: (vendors) => set({ vendors }),

  addVendor: (vendor) =>
    set((state) => ({
      vendors: {
        ...state.vendors,
        items: [vendor, ...state.vendors.items],
        totalItems: state.vendors.totalItems + 1,
      },
    })),

  updateVendorInList: (vendor) =>
    set((state) => {
      const items = [...state.vendors.items];
      const index = items.findIndex((v) => v.uid === vendor.uid);
      if (index !== -1) {
        items[index] = { ...items[index], ...vendor };
      } else {
        items.unshift(vendor);
      }
      return {
        vendors: {
          ...state.vendors,
          items,
        },
      };
    }),

  deleteVendorFromList: (uid) =>
    set((state) => ({
      vendors: {
        ...state.vendors,
        items: state.vendors.items.filter((v) => v.uid !== uid),
        totalItems: Math.max(0, state.vendors.totalItems - 1),
      },
    })),

  setVendorForm: (form) => set({ vendorForm: form }),
  resetVendorForm: () => set({ vendorForm: null }),
}));
